//
//
//
//
//
//
//

import NoData from '../NoData/NoData.vue';
import MHeader from '../Header/Header.vue';
import List from './list.vue';
import {
    shopAllCoupon
} from '../../api';
export default {
    components: {
        MHeader,
        NoData,
        List
    },
    data() {
        return {
            list: []
        }
    },
    created() {
        this.$store.commit('showIsLoading');
        shopAllCoupon().then(res => {
            if (res.data.error_code) {
                this.$router.go(-1);
                console.error(res);
                return;
            };
            this.list = res.data.coupon;
            console.log(res.data);
        })
    }
};



// WEBPACK FOOTER //
// ./src/components/HomeCoupon/HomeCoupon.vue